import React from "react";

import Bouton, { VARIANT } from "@/ui/bouton";
import ModalRegular from "@/ui/modal/regular";

import styles from "./modal.module.scss";

type FiltreModalProps = {
    children: React.ReactNode;
    handleClear: () => void;
    handleClose: () => void;
    isOpen: boolean;
    total: number;
};

const FiltreModal = ({ children, handleClear, handleClose, isOpen, total }: FiltreModalProps) => {
    return (
        <ModalRegular
            headerCaption="Filtres avancés"
            headerCaptionAddon={`${total} résultat${total > 1 ? "s" : ""}`}
            isOpen={isOpen}
            onHide={handleClose}
        >
            <section className="section">{children}</section>
            <footer className={styles.footer}>
                <Bouton
                    className={styles.buttonDelete}
                    color="dark"
                    icon="delete"
                    onClick={handleClear}
                    variant={VARIANT.LINK}
                >
                    Effacer les filtres
                </Bouton>
                <Bouton className={styles.buttonValidate} count={total} onClick={handleClose}>
                    Voir les résultats
                </Bouton>
            </footer>
        </ModalRegular>
    );
};

export default FiltreModal;
